import { RNG } from "rot-js";
import { Actor } from "../../actors/Actor";
import { BreedTypes } from "../../actors/breeds";
import EntityManager from "../../EntityManager";
import { gameData } from "../../GameManager";
import { makeRect } from "../carving/Carving";
import { BSPGenerate } from "../graph/BSPGenerator";
import { GraphNode } from "../graph/graphUtils";
import { placeMonsters } from "../placement/MonsterPlacement";
import { placeShrines } from "../placement/ShrinePlacement";
import { ShrineMap } from "../ShrineMap";
import { connectRooms, connectZLevels } from "./connections";

export const generateMap = (
  rng: typeof RNG,
  map: ShrineMap,
  player?: Actor
) => {
  const rooms = BSPGenerate(rng, map.width - 1, map.height - 1);
  map.generate(rng);
  let room: GraphNode;
  for (room of rooms.values()) {
    makeRect(map, room.bounds, room.z);
  }

  connectRooms(rng, rooms, map);
  connectZLevels(rng, map, rooms);

  const [oldPos, startingRoom] = placeShrines(rng, map, rooms);
  if (player) {
    player.x = oldPos.x;
    player.y = oldPos.y;
  } else {
    gameData.player = EntityManager.createActor(
      BreedTypes.player,
      oldPos.x,
      oldPos.y
    );
  }
  placeMonsters(rng, map, rooms, startingRoom);
};
